import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { environment } from "../../../../environments/environment";
import { Utility } from '../../core/utils/utility';

@Injectable({
  providedIn: 'root'
})
export class LessonsService {
  constructor(private http: HttpClient) {
  }

  get(filter: any | null = null) {
    let params = new HttpParams();
    for (const key in filter) {
      if (filter[key])
        params = params.append(key, filter[key])
    }

    return this.http.get(`${environment.apiUrl}/InnovationLesson`, { params: params })
  }

  getById(lessonId: number) {
    return this.http.get(`${environment.apiUrl}/Lesson/GetById?Id=${lessonId}`)
  }

  getSessionStartups(sessionId: string | number) {
    return this.http.get(`${environment.apiUrl}/InnovationLesson/session/startups?sessionId=${sessionId}`)
  }

  delete(lessonId: number) {
    return this.http.delete(`${environment.apiUrl}/InnovationLesson?Id=${lessonId}`)
  }

  add(value: any) {
    let formData = Utility.objectToFormData(value);

    let options = {
      headers: new HttpHeaders({
        "x-none": "true",
        "enctype": "multipart/form-data",
      }),
    };
    return this.http.post(`${environment.apiUrl}/InnovationLesson`, formData, options)
  }

  update(value: any) {
    let formData = Utility.objectToFormData(value);

    let options = {
      headers: new HttpHeaders({
        "x-none": "true",
        "enctype": "multipart/form-data",
      }),
    };
    return this.http.put(`${environment.apiUrl}/InnovationLesson`, formData, options)
  }

  deleteAttachment(id: any) {
    return this.http.delete(`${environment.apiUrl}/InnovationLesson/attachment`, { params: { id } });
  }

}
